import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const inputCls = "w-full bg-background border border-input px-4 py-2.5 text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed.";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20 px-6">
      <div className="w-full max-w-md">
        <div className="relative">
          <div className="absolute -inset-2 border-2 border-accent" aria-hidden />
          <form onSubmit={submit} className="relative bg-card border border-border p-8 md:p-10" data-testid="admin-login-form">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-primary text-primary-foreground flex items-center justify-center"><Lock size={20} /></div>
              <div>
                <h1 className="font-serif text-2xl font-bold text-primary leading-tight">Campaign Admin</h1>
                <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground font-bold">Sign in</p>
              </div>
            </div>
            <div className="space-y-5">
              <label className="block">
                <span className="block text-xs uppercase tracking-[0.18em] font-bold text-primary mb-2">Email</span>
                <input required type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
              </label>
              <label className="block">
                <span className="block text-xs uppercase tracking-[0.18em] font-bold text-primary mb-2">Password</span>
                <input required type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
              </label>
              <button
                type="submit"
                disabled={submitting}
                data-testid="admin-login-submit"
                className="w-full bg-primary text-primary-foreground py-3 font-bold uppercase tracking-wider hover:bg-[#072448] transition-colors disabled:opacity-60"
              >
                {submitting ? "Signing in…" : "Sign In"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
